import type { IconSvgObject } from './types';

const SmartPhoneLandscapeIcon: IconSvgObject = [
  ["path", { d: "M2 7.5L2 16.5C2 17.6046 2.89543 18.5 4 18.5L20 18.5C21.1046 18.5 22 17.6046 22 16.5V7.5C22 6.39543 21.1046 5.5 20 5.5L4 5.5C2.89543 5.5 2 6.39543 2 7.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.125 12H19M19.25 12C19.25 12.1381 19.1381 12.25 19 12.25C18.8619 12.25 18.75 12.1381 18.75 12C18.75 11.8619 18.8619 11.75 19 11.75C19.1381 11.75 19.25 11.8619 19.25 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SmartPhoneLandscapeIcon;
